"use strict";

require("core-js/modules/es.object.define-property.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = NotFoundException;
require("core-js/modules/es.function.name.js");
function NotFoundException(data) {
  this.name = 'NotFoundException';
  this.data = data;
  this.message = JSON.stringify(data);
  this.stack = new Error().stack;
}
NotFoundException.constructor = NotFoundException;